import React from 'react';
import { Headset } from 'lucide-react';

const SupportButton: React.FC = () => {
  return (
    <a
      href="https://stellionet.freshdesk.com/"
      target="_blank"
      /* rel="noopener noreferrer": Crucial por seguridad al usar target="_blank" 
         evita ataques de tabnabbing y mejora el rendimiento */
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 bg-secondary text-white border-2 border-secondary hover:border-white rounded-full shadow-2xl hover:scale-110 hover:bg-primary transition-all duration-300 group"
      /* aria-label: Proporciona un nombre accesible al enlace para lectores de pantalla */
     aria-label="Contactar con soporte técnico por WhatsApp"
      /* title: */
      title="Centro de Soporte"
    >
      {/* Icono de Soporte: */}
      <Headset 
        size={28} 
        className="group-hover:rotate-45 transition-transform duration-500" 
        aria-hidden="true" 
      />

      {/* Etiqueta flotante (Tooltip): */}
      <span 
        role="tooltip"
        className="absolute right-16 opacity-0 group-hover:opacity-100 font-semibold transition-opacity bg-surface text-primary text-sm px-3 py-1.5 rounded-md whitespace-nowrap pointer-events-none shadow-lg border border-secondary"
      >
        Centro de Soporte
      </span>
    </a>
  );
};

export default SupportButton;